import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { attributionApi } from '@/api/attributionApi';
import { useUIStore } from '@/state/uiStore';
import css from './forms.module.css';

export function DatePicker() {
  const fund = useUIStore((s) => s.selectedFund);
  const date = useUIStore((s) => s.selectedDate);
  const setDate = useUIStore((s) => s.setSelectedDate);

  const q = useQuery({
    queryKey: ['dates', fund],
    queryFn: () => attributionApi.dates(fund),
    staleTime: 60 * 60 * 1000,
  });

  // When fund changes, default to its latest available date.
  useEffect(() => {
    if (q.data && (!date || !q.data.dates.includes(date))) {
      setDate(q.data.max);
    }
  }, [q.data, date, setDate]);

  if (q.isLoading) {
    return <div className={css.field}><span className={css.label}>Date</span><span className={css.muted}>Loading…</span></div>;
  }
  if (!q.data) {
    return <div className={css.field}><span className={css.label}>Date</span><span className={css.muted}>—</span></div>;
  }

  return (
    <div className={css.field}>
      <label htmlFor="date-picker" className={css.label}>Date</label>
      <input
        id="date-picker"
        type="date"
        className={css.input}
        value={date ?? q.data.max}
        min={q.data.min}
        max={q.data.max}
        onChange={(e) => {
          const v = e.target.value;
          // Clamp to nearest available date
          if (q.data!.dates.includes(v)) {
            setDate(v);
          } else {
            // Pick the closest available date
            const target = new Date(v).getTime();
            let best = q.data!.dates[0]!;
            let bestDelta = Math.abs(new Date(best).getTime() - target);
            for (const d of q.data!.dates) {
              const delta = Math.abs(new Date(d).getTime() - target);
              if (delta < bestDelta) { best = d; bestDelta = delta; }
            }
            setDate(best);
          }
        }}
      />
    </div>
  );
}
